import React from 'react';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
const painPoints = ['Querés emprender pero no sabés qué vender ni cómo arrancar', 'Tenés miedo de invertir plata y perderla porque todo en Argentina cambia todo el tiempo', 'Sentís que otras avanzan mientras vos seguís pensando "algún día voy a empezar"', 'No sabés cómo usar WhatsApp o Instagram para convertir consultas en ventas', 'Buscás una oportunidad femenina, simple y compatible con tu fe', 'Terminás cada domingo prometiéndote que "mañana sí vas a empezar"'];
export function PainBlock() {
  return <section className="py-24 sm:py-28 px-4 bg-[#F5EEFF] border-t border-white/5 relative" data-id="element-211">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-213">
          <h2 className="font-extrabold text-[#4A1B6D] mb-8 text-[26px] sm:text-[40px] text-center mx-auto max-w-[18ch] sm:max-w-[22ch] uppercase tracking-tight" style={{
          lineHeight: 1.15,
          textShadow: '0 2px 6px rgba(74, 27, 109, 0.08)',
          fontWeight: 800
        }} data-id="element-214">
            ❌ ¿Cuántos domingos más vas a terminar así?
          </h2>
          <p className="text-gray-700 mb-4 text-[16px]" data-id="element-215">
            Sos una mujer de fe. Querés generar ingresos desde casa. Pero nadie
            te dijo que ibas a pasar los domingos buscando ideas para emprender,
            mirando videos que no explican nada y llegando al lunes sin saber
            por dónde empezar.
          </p>
          <p className="text-xl font-bold text-brand-purple mt-8" data-id="element-216">
            No es falta de ganas. Es falta de un sistema.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-l-4 border-brand-purple p-6 sm:p-10 rounded-r-2xl shadow-lg" data-id="element-217">
          <p className="font-bold text-gray-600 uppercase tracking-wider text-sm mb-6" data-id="element-218">
            ❌ Lo que estás viviendo ahora mismo:
          </p>

          <ul className="space-y-4 mb-10" data-id="element-219">
            {painPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-left" data-id="element-220">
                <X className="text-brand-pink shrink-0 mt-1" size={20} data-id="element-221" />
                <span className="text-gray-800 font-medium leading-relaxed" data-id="element-222">
                  {point}
                </span>
              </li>)}
          </ul>

          <div className="pt-8 border-t border-gray-200" data-id="element-223">
            <p className="sm:text-3xl font-extrabold text-[20px] text-brand-purple" data-id="element-224">
              ¿Y si este fuera el último domingo que pasó así?
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}